// Mapa único rota → permissões (any-of). Usado por ProtectedRoute (App.js) e pelo menu (Layout.js).
export const ROUTE_PERMS = {
  '/dashboard': ['ver_dashboard'],
  '/kanban': ['ver_kanban'],
  '/lista': ['ver_internacoes'],
  '/tarefas': ['ver_tarefas'],
  '/prescricao': ['ver_prescricao'],
  '/dispensacao': ['ver_dispensacao'],
  '/visitas': ['ver_checkins'],
  '/guias': ['ver_guias'],
  '/recebimento-guias': ['ver_recebimento'],
  '/fechamento-mensal': ['ver_fechamento'],
  '/primeiros-atendimentos': ['ver_primeiros_atendimentos', 'ver_primeiros_atendimentos_todos'],
  '/diarias': ['ver_diarias'],
  '/estatisticas': ['ver_estatisticas'],
  '/custos': ['ver_custos'],
  '/auditoria-financeira': ['ver_auditoria_financeira'],
  '/auditoria-prontuarios': ['ver_auditoria_financeira', 'gerenciar_primeiros_atendimentos'],
  '/estoque': ['ver_estoque'],
  '/sku': ['ver_sku'],
  '/aprovisionamento': ['ver_aprovisionamento'],
  '/comodato': ['ver_comodato'],
  '/fisioterapia': ['ver_especialidades'],
  '/relatorios': ['ver_relatorios'],
  '/servicos': ['ver_servicos'],
  '/mapa': ['ver_mapa'],
  '/pacientes': ['ver_pacientes'],
  '/pacientes/novo': ['criar_pacientes'],
  '/agente-ia': ['usar_agente_ia'],
  '/metricas': ['ver_metricas'],
  '/medicina-direta': ['ver_medicina_direta'],
  '/admin-seguranca': [], // página exclusiva de master_admin (verificação própria + backend)
  '/configuracoes': [], // preferências pessoais (senha/notificações); abas administrativas protegidas na página
  '/alterar-senha': [],
};

// Rotas dinâmicas (prefixo/regex) → permissões
const DYNAMIC = [
  [/^\/pacientes\/[^/]+\/nova-internacao$/, ['criar_internacoes']],
  [/^\/pacientes\/[^/]+\/internacao\/[^/]+$/, ['ver_internacoes']],
  [/^\/pacientes\/[^/]+$/, ['ver_pacientes']],
  [/^\/lista\//, ['ver_internacoes']],
];

export const permsForPath = (pathname) => {
  if (ROUTE_PERMS[pathname] !== undefined) return ROUTE_PERMS[pathname];
  const d = DYNAMIC.find(([rx]) => rx.test(pathname));
  return d ? d[1] : null; // null = rota desconhecida (só login)
};

// Ordem de preferência da página inicial
export const HOME_ORDER = ['/dashboard', '/kanban', '/lista', '/fisioterapia', '/visitas', '/guias', '/recebimento-guias', '/estoque', '/configuracoes'];
export const homeFor = (can) => HOME_ORDER.find((r) => ROUTE_PERMS[r].length === 0 || can(...ROUTE_PERMS[r])) || '/configuracoes';
